function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "error",
  transform: "translate(-1142.000000, -70.000000)",
  fill: "#E74C3C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  transform: "translate(1118.000000, 54.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.319238,31.680762 C29.9155282,33.2457033 31.8090822,34.0281239 34,34.0281239 C36.1909178,34.0281239 38.0688474,33.2457033 39.6337887,31.680762 C41.2300789,30.0844718 42.0281239,28.1909178 42.0281239,26 C42.0281239,23.8090822 41.2300789,21.9311526 39.6337887,20.3662113 C38.0688474,18.7699211 36.1909178,17.9718761 34,17.9718761 C31.8090822,17.9718761 29.9155282,18.7699211 28.319238,20.3662113 C26.7542967,21.9311526 25.9718761,23.8090822 25.9718761,26 C25.9718761,28.1909178 26.7542967,30.0844718 28.319238,31.680762 Z M26.9108409,18.9578142 C28.8826169,16.9859381 31.2457033,16 34,16 C36.7542967,16 39.1017587,16.9859381 41.0421858,18.9578142 C43.0140619,20.8982413 44,23.2457033 44,26 C44,28.7542967 43.0140619,31.1173831 41.0421858,33.0891591 C39.1017587,35.0296863 36.7542967,36 34,36 C31.2457033,36 28.8826169,35.0296863 26.9108409,33.0891591 C24.9703137,31.1173831 24,28.7542967 24,26 C24,23.2457033 24.9703137,20.8982413 26.9108409,18.9578142 Z M33.0140619,20.9765634 L34.9859381,20.9765634 L34.9859381,26.9859381 L33.0140619,26.9859381 L33.0140619,20.9765634 Z M33.0140619,29.0046873 L34.9859381,29.0046873 L34.9859381,31.0234366 L33.0140619,31.0234366 L33.0140619,29.0046873 Z",
  id: "Shape"
}))));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.2db91131.svg";
export { ForwardRef as ReactComponent };